import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Backdrop } from "@mui/material";
import { useNavigate, Outlet } from "react-router-dom";

import { fetchCategories } from "../../api/catalogApi";
import Header from "./Header";
import Navigation from "./Navigation";
import Footer from "./Footer";

import { CartProvider } from "../Cart/CartContext";

export default function Layout() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await fetchCategories();

        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.results)
            ? data.results
            : [];

        setCategories(list);
      } catch (err) {
        console.error("Category load failed", err);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, []);

  if (loading) {
    return (
      <Backdrop open={true} sx={{ color: "#fff", zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <>
      <Box sx={{ position: "sticky", top: 0, zIndex: 1100, width: "100%" }}>
        <Header
          categories={categories}
          onCategorySelect={(slug) => navigate(`/category/${slug}`)}
        />
        <Navigation
          categories={categories}
          handleCategorySelection={(slug) => navigate(`/category/${slug}`)}
        />
      </Box>

      <Box component="main" sx={{ minHeight: "80vh", p: 2 }}>
        <Outlet />
      </Box>

      <Footer />
    </>
  );
}
